import CircularRectTextButton, {
    CircularRectTextButtonProps,
} from "@/components/CircularButton/styled/CircularRectTextButton";
import Link from "@/components/wrappers/Link";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";

const CustomizePlanButton = ({
    buttonStyle,
    ...props
}: CircularRectTextButtonProps & { buttonStyle?: React.CSSProperties }) => {
    return (
        <Link href={"/schools/customize"} className="strippedLink">
            <CircularRectTextButton
                component={"div"}
                style={{
                    backgroundColor: themeColors.primary,
                    color: themeColors.primaryDark,
                    padding: `${spacing.SM} ${spacing.MD}`,
                    width: "fit-content",
                    ...buttonStyle,
                }}
                {...props}>
                {"Customize a plan"}
            </CircularRectTextButton>
        </Link>
    );
};

export default CustomizePlanButton;
